module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Want to work with us?","text":"Want to know more? We\u0027d love to hear from you! Get in touch with us to learn more about what we can do for you.","button":"Currently unavailable"},"nl":{"title":"Gaan we samenwerken?","text":"Meer weten? We horen graag van je! Neem contact op als je meer te weten wilt komen over onze diensten.","button":"Momenteel niet beschikbaar"}}')
  delete Component.options._Ctor
}
